/* ================================================================
   NayRosa — enhance.js
   Small add-ons layered on top of global.js:
     1) Community videos: inline playback (first autoplays, others click-to-play)
     2) PDP mobile sticky bar: reveal only after the inline buy buttons scroll away
     3) PDP "Add a 2nd" upsell: checkbox bumps the add-to-cart quantity to 2
     4) Sticky header: add an elevation shadow once the page is scrolled
     5) Hero: auto-rotating (crossfade) images
   ================================================================ */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Community videos: inline play ---------- */
  document.addEventListener('click', function (e) {
    var pb = e.target.closest('[data-ugc-play]');
    if (pb) {
      var card = pb.closest('.ugc');
      var vid = card && card.querySelector('video');
      if (vid) {
        $$('.ugc video').forEach(function (v) { if (v !== vid) v.pause(); });
        vid.muted = false;
        var p = vid.play(); if (p && p.catch) p.catch(function () {});
        pb.style.display = 'none';
      }
      return;
    }
    var eb = e.target.closest('[data-ugc-embed]');
    if (eb) {
      var url = eb.getAttribute('data-url');
      var c = eb.closest('.ugc');
      if (c && url) {
        var iframe = document.createElement('iframe');
        iframe.src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1&playsinline=1&rel=0';
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('title', 'Video');
        c.appendChild(iframe);
        eb.style.display = 'none';
      }
    }
  });
  $$('.ugc video').forEach(function (v) {
    v.addEventListener('play', function () {
      $$('.ugc video').forEach(function (o) { if (o !== v) o.pause(); });
    });
  });

  /* ---------- PDP sticky bar ---------- */
  (function () {
    var inline = $('.buy .buy-cta');
    var sticky = $('.sticky-bar');
    if (!inline || !sticky || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('visible', scrolledPast);
      });
    }, { threshold: 0 });
    io.observe(inline);
  })();

  /* ---------- PDP "Add a 2nd" upsell: bump quantity to 2 when checked ---------- */
  $$('[data-addon-2nd]').forEach(function (cb) {
    var form = cb.closest('form[data-cart-form]');
    var qty = form ? form.querySelector('[name="quantity"]') : null;
    if (!qty) return;
    var prev = qty.value;
    cb.addEventListener('change', function () {
      if (cb.checked) {
        prev = qty.value;
        if ((parseInt(qty.value, 10) || 1) < 2) qty.value = 2;
      } else {
        qty.value = (prev && parseInt(prev, 10) > 0) ? prev : 1;
      }
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---------- Sticky header: elevation shadow on scroll ---------- */
  (function () {
    var header = $('.header');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  /* ---------- Hero: auto-rotating (crossfade) images ---------- */
  $$('[data-hero-slides]').forEach(function (shot) {
    if (!shot.hasAttribute('data-hero-autoplay')) return;
    var overlays = $$('.hero-ov', shot);
    if (!overlays.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var total = overlays.length + 1; // base image + overlays
    var interval = parseInt(shot.getAttribute('data-hero-interval'), 10) || 5000;
    if (interval < 2000) interval = 2000;
    var i = 0;
    setInterval(function () {
      if (document.hidden) return;
      i = (i + 1) % total;
      overlays.forEach(function (ov, idx) { ov.classList.toggle('is-active', idx === i - 1); });
    }, interval);
  });
})();
